import { Component } from 'react';
import { CoreType } from '../index.d';
import * as PropTypes from 'prop-types';
import * as React from 'react';

export type AppProviderProps = {
  app: CoreType;
};

export type AppProviderContext = {
  appInstance: CoreType;
};

export const appProviderContextTypes = {
  appInstance: PropTypes.any
};

export class AppProvider extends Component<AppProviderProps, {}> {

  static childContextTypes = appProviderContextTypes;

  getChildContext(): AppProviderContext {
    return { appInstance: this.props.app };
  }

  componentWillReceiveProps(nextProps: AppProviderProps) {
    if (this.props.app !== nextProps.app) {
      console.warn(`AppProvider does not support props update !`);
    }
  }

  shouldComponentUpdate() {
    return false;
  }

  render(): JSX.Element {
    return React.Children.only(this.props.children);
  }

}



// WEBPACK FOOTER //
// src/app/src/core/components/AppProvider.ts